import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddYurticiCargoRequest } from '../models/request/yurticiCargo/AddYurticiCargoRequest';
import { GetYurticiCargoListPagingAndFilterRequest } from '../models/request/yurticiCargo/GetYurticiCargoListPagingAndFilterRequest';
import { YurticiCargoFindPriceRequest } from '../models/request/yurticiCargo/YurticiCargoFindPriceRequest';

export class YurticiCargoService {
    /** "Yurtiçi Kargo Sipariş Güncelleme" rolü: Müşteri / Bölüm / PO / PO No elle güncellenir ve kayıt kilitlenir. */
    static async updateYurticiCargoPo(_id: string, _customerId: string | undefined, _divisionId: string | undefined, _poId: string | undefined, _poNo: string | undefined) {
        try {
            const inputObj = { id: _id, customerId: _customerId, divisionId: _divisionId, poId: _poId, poNo: _poNo };

            console.log('SERVICE CALL - updateYurticiCargoPo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/UpdateYurticiCargoPo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Kilidi kaldırır: kayıt yeniden entegrasyona ve toplu PO güncellemesine bırakılır. */
    static async unlockYurticiCargoPo(_id: string) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/UnlockYurticiCargoPo', { id: _id });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoList(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - getYurticiCargoList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/getYurticiCargoList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportYurticiCargoList(inputObj: GetYurticiCargoListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportYurticiCargoList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/exportYurticiCargoList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoListPagingAndFilter(inputObj: GetYurticiCargoListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetYurticiCargoListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/GetYurticiCargoListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addYurticiCargo(inputObj: AddYurticiCargoRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddYurticiCargo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/AddYurticiCargo', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteYurticiCargo(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteYurticiCargo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/deleteYurticiCargo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getYurticiCargoById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/getYurticiCargoById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Üst bardaki zil: seçili firmanın PO'su boş aktif Yurtiçi kargo sayısı. */
    static async getPoUnmatchedCount(): Promise<{ isSuccess: boolean, message?: string, data: number }> {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/GetPoUnmatchedCount', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoUnitList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getYurticiCargoUnitList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/getYurticiCargoUnitList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async yurticiCargoFindPrice(inputObj: YurticiCargoFindPriceRequest) {
        try {
            console.log('SERVICE CALL - yurticiCargoFindPrice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/yurticiCargoFindPrice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async updatePo(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids,
            };

            console.log('SERVICE CALL - updatePo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/updatePo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addInvoiceFromYurticiCargo(_yurticiCargoId: string, _isSale: boolean, _currencyTypeId: string, _invoiceId?: string, _ignoreWithholding?: boolean) {
        try {
            var inputObj = {
                yurticiCargoId: _yurticiCargoId,
                isSale: _isSale,
                currencyTypeId: _currencyTypeId,
                invoiceId: _invoiceId,
                ignoreWithholding: _ignoreWithholding
            };

            console.log('SERVICE CALL - addInvoiceFromYurticiCargo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/addInvoiceFromYurticiCargo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }


    /** Faturası eksik kargoların alış fatura numarasını tamamlar. */
    static async completeMissingInvoices(maxRecords: number = 200) {
        try {
            console.log('SERVICE CALL - CompleteMissingInvoices', maxRecords);

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargo/CompleteMissingInvoices', { maxRecords: maxRecords });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}